// src/db.js
import firebase from 'firebase';

// ✅ Firebase configuration for "pixels-to-players-active" project
const firebaseConfig = {
  apiKey: "AIzaSyDZMsuefJGdfegQyoP7TEPT_JgMyg_ye1E",
  authDomain: "pixels-to-players-active.firebaseapp.com",
  projectId: "pixels-to-players-active",
  storageBucket: "pixels-to-players-active.firebasestorage.app",
  messagingSenderId: "134410011176",
  appId: "1:134410011176:web:9bcbd629660ade04ddab1d",
  measurementId: "G-KN2RLXKYE2"
};

// Initialize Firebase unconditionally (no apps.length check)
const app = firebase.initializeApp(firebaseConfig);

// Export services
export const db = firebase.firestore();
export const auth = firebase.auth();
export const storage = firebaseConfig.storageBucket;
let functionsInstance = null;
if (typeof firebase.functions === 'function') {
  functionsInstance = firebase.functions();
}
export const functions = functionsInstance;

export default firebase;



// WEBPACK FOOTER //
// ./src/db.js